import React from 'react';
import { 
  BsBell, 
  BsLightningCharge, 
  BsShieldCheck 
} from 'react-icons/bs';

import { useNavigate } from 'react-router-dom';
import { useDashboard } from '../context/DashboardContext';

export default function UpcomingExpiring() {
  const navigate = useNavigate();
  const { dashboardData, loading, errors } = useDashboard();
  const items = (dashboardData.upcomingExpiring || []).map(row => ({ ...row,
    dueText: row.days === 0 ? 'Due today' : row.days === 1 ? 'Due tomorrow' : 'Due in ' + row.days + ' days',
    isUrgent: row.days <= 7,
    icon: row.kind === 'pat' ? <BsLightningCharge className="text-lg text-amber-500" /> : row.kind === 'maintenance' ? <BsBell className="text-lg text-amber-500" /> : <BsShieldCheck className="text-lg text-red-500" />,
    iconBg: row.days <= 7 ? 'bg-red-50' : 'bg-amber-50',
  }));

  return (
    <div className="max-w-xl w-full bg-white border border-slate-100 rounded-3xl p-6 shadow-sm font-sans text-slate-800">
      
      {/* HEADER SECTION */}
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-bold text-slate-900">Upcoming / Expiring</h2>
        <button onClick={() => navigate("/equipment")} className="text-[#3a31d8] text-xs font-bold hover:underline">
          View All
        </button>
      </div>

      {/* ITEMS LIST BOX */}
      <div className="border border-slate-100 rounded-2xl bg-white px-5 divide-y divide-slate-100 mb-4">
        {!items.length && <p className="py-4 text-sm text-slate-400">{loading.upcomingExpiring ? 'Loading…' : errors.upcomingExpiring ? 'Unable to load upcoming dates.' : 'No equipment dates due in the next 30 days.'}</p>}
        {items.map((item) => (
          <div key={item.id} className="py-4 flex items-center justify-between gap-4">
            
            {/* Left Content Side */}
            <div className="flex items-center gap-3.5 min-w-0">
              <div className={`p-2 rounded-xl shrink-0 ${item.iconBg}`}>
                {item.icon}
              </div>
              <span className="text-sm font-bold text-slate-800 truncate">
                {item.title}
              </span>
            </div>

            {/* Right Status Text */}
            <span className={`text-xs font-bold shrink-0 ${
              item.isUrgent ? 'text-red-500' : 'text-amber-500'
            }`}>
              {item.dueText}
            </span>

          </div>
        ))}
      </div>

      {/* BOTTOM ACTION BUTTON */}
      <button className="w-full bg-[#f4f3ff] hover:bg-[#e9e7ff] text-[#3a31d8] py-3 rounded-xl text-xs font-bold transition flex items-center justify-center border border-transparent active:border-slate-200">
        <span>View All Upcoming</span>
      </button>

    </div>
  );
}
